// OneDrive:IgnoreCodeCoverage

import { createSingleEvent } from '../SingleEventBase';
import { IEventType } from '../EventBase';
import { IEvent, EventFieldType } from '../IEvent';
export interface IRUMOneDataUploadSingleSchema {
    /**
     * SLAPI stream name the data will be logged to, must be either RUMOne or RUMOneErrors
     */
    streamName: string;
    /**
     * Data of the RUMOne or RUMOneErrors
     */
    // tslint:disable-next-line:no-any
    dictionary: { [key: string]: any; };
}

export interface IRUMOneDataUpload extends IEvent {
    data: IRUMOneDataUploadSingleSchema;
}

export type RUMOneDataUpload = IRUMOneDataUpload;

export const RUMOneDataUpload: IRUMOneDataUploadType = createSingleEvent<IRUMOneDataUploadSingleSchema>({
    eventName: 'RUMOneDataUpload,',
    shortEventName: 'RUMOneDataUpload'
}, {
        streamName: EventFieldType.String,
        dictionary: EventFieldType.Object
    });

export interface IRUMOneDataUploadType extends IEventType<IRUMOneDataUploadSingleSchema> {
    prototype: RUMOneDataUpload;
    /**
     * This will create a single RUMOneDataUpload event
     * @param data {IRUMOneDataUploadSingleSchema}
     * * -required streamName - SLAPI stream name the data will be logged to, must be either RUMOne or RUMOneErrors
     * -required dictionary - Data of the RUMOne or RUMOneErrors
     * @param parent {IEvent} The optional parent for this event
     */
    logData(this: typeof RUMOneDataUpload, data?: IRUMOneDataUploadSingleSchema, parent?: IEvent): RUMOneDataUpload;
}
